import { render } from "./updatetype.vue?vue&type=template&id=d8109174"
import script from "./updatetype.vue?vue&type=script&lang=js"
export * from "./updatetype.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__